import { useI18n } from '../i18n'
import { readJournal, streakDays } from '../lib/journal'
import { useSession } from '../store/session'

export function Home() {
  const { t } = useI18n()
  const s = useSession()

  const j = readJournal()
  const n = streakDays(j)
  const streak = !j.length ? t.streak.first : n ? t.streak.active(n, j.length) : t.streak.broken(j.length)

  const startFree = () => {
    s.set({ mode: 'free', strokes: [], exStrokes: [], beforePNG: null, afterPNG: null, entryId: null, captureMode: 'canvas', postDraft: '' })
    s.go('draw')
  }
  const startTherapy = () => {
    s.set({ mode: 'therapy', strokes: [], exStrokes: [], beforePNG: null, afterPNG: null, entryId: null, captureMode: 'canvas', postDraft: '', calmArcs: 0 })
    s.go('pre')
  }

  return (
    <section className="screen">
      <h1>{t.home.title}</h1>

      <div className="mode-card" onClick={startFree}>
        <div className="mode-ico" style={{ background: 'var(--sage-soft)' }}>
          <svg viewBox="0 0 24 24" stroke="#4C8A6B">
            <path d="M4 20 C 8 8, 10 16, 13 7 S 19 14, 20 5" />
          </svg>
        </div>
        <div className="mode-t">
          <b>{t.home.freeTitle}</b>
          <span>{t.home.freeDesc}</span>
        </div>
      </div>

      <div className="mode-card" onClick={startTherapy}>
        <div className="mode-ico" style={{ background: 'var(--blue-soft)' }}>
          <svg viewBox="0 0 24 24" stroke="#3347E0">
            <path d="M4 16 L8 6 L12 18" />
            <path d="M12 18 C 15 10, 19 12, 20 8" />
          </svg>
        </div>
        <div className="mode-t">
          <b>{t.home.therapyTitle}</b>
          <span>{t.home.therapyDesc}</span>
        </div>
      </div>

      <p className="streak" dangerouslySetInnerHTML={{ __html: streak }} />
      <footer>{t.home.footer}</footer>
    </section>
  )
}
